import type { RenderConfig } from '../types/becky'

export const InitSymbol = Symbol('InitSymbol')

export type FeatureName =
	'accessibility' |
	'activePopup' |
	'activeVariantsApi' |
	'addressInput' |
	'anchorsService' |
	'animations' |
	'animationsWixCodeSdk' |
	'appMonitoring' |
	'applePay' |
	'assetsLoader' |
	'authenticationWixCodeSdk' |
	'autoDisplayLightbox' |
	'backgroundGroup' |
	'backgroundScrub' |
	'blockingLayer' |
	'bookings' |
	'breadcrumbs' |
	'builderComponent' |
	'builderComponentHierarchy' |
	'builderComponentRefs' |
	'builderContextProviders' |
	'builderModuleLoader' |
	'builderModulesLoader' |
	'businessLogger' |
	'businessLoggerService' |
	'businessManager' |
	'canvas' |
	'captcha' |
	'chat' |
	'clickHandlerRegistrar' |
	'clientSdk' |
	'coBranding' |
	'codeEmbed' |
	'commonConfig' |
	'components' |
	'componentsLoader' |
	'componentsMeasures' |
	'componentsPreviewTooltip' |
	'componentsQaApi' |
	'componentsReact' |
	'componentsRegistry' |
	'componentsUpdatesManager' |
	'consentPolicy' |
	'consentPolicyService' |
	'containerSlider' |
	'containerSliderService' |
	'contentReflow' |
	'cookiesManager' |
	'crmWixCodeSdk' |
	'customCss' |
	'customUrlMapper' |
	'cyclicTabbing' |
	'cyclicTabbingService' |
	'dashboardWixCodeSdk' |
	'dataWixCodeSdk' |
	'debug' |
	'debugDs' |
	'domStore' |
	'dynamicPages' |
	'editorAnimations' |
	'editorElementsDynamicTheme' |
	'editorNavigation' |
	'editorPopups' |
	'editorRouter' |
	'editorWixCodeSdk' |
	'elementorySupportWixCodeSdk' |
	'embeddedInIframe' |
	'environment' |
	'environmentService' |
	'environmentWixCodeSdk' |
	'experiments' |
	'externalComponent' |
	'extraSiteHeight' |
	'fedops' |
	'fedopsLoggerService' |
	'fedopsWixCodeSdk' |
	'feedback' |
	'fileUploader' |
	'freemiumBanner' |
	'headerContainer' |
	'hoverBox' |
	'imagePlaceholder' |
	'imagePlaceholderService' |
	'imageZoom' |
	'interactions' |
	'landingPage' |
	'lightbox' |
	'lightboxService' |
	'linkUtilsService' |
	'locationWixCodeSdk' |
	'loginButton' |
	'manifestManager' |
	'mappersLegacyService' |
	'measuresApi' |
	'membersService' |
	'menuContainer' |
	'menusCurrentPage' |
	'mobileActionsMenu' |
	'mobileFullScreen' |
	'modelUpdatesInvoker' |
	'motion' |
	'motionEffects' |
	'mpaNavigation' |
	'multilingual' |
	'namedSignalsService' |
	'nativeMobileWixCodeSdk' |
	'navigation' |
	'navigationManager' |
	'navigationPhases' |
	'onloadCompsBehaviors' |
	'ooi' |
	'ooiTpaSharedConfig' |
	'pageAnchors' |
	'pageContextService' |
	'pageScroll' |
	'pageTransitions' |
	'pages' |
	'paidPlansWixCodeSdk' |
	'panorama' |
	'passwordProtectedPage' |
	'platform' |
	'platformPubsub' |
	'popupLink' |
	'pricingPlansWixCodeSdk' |
	'protectedPages' |
	'provideComponentService' |
	'provideCssService' |
	'qaApi' |
	'quickActionBar' |
	'realtimeWixCodeSdk' |
	'remoteStructureRenderer' |
	'render' |
	'renderIndicator' |
	'renderer' |
	'repeaters' |
	'reporter' |
	'router' |
	'routerFetch' |
	'routerService' |
	'screenIn' |
	'scrollRestoration' |
	'scrollToAnchor' |
	'sdkStateService' |
	'searchBox' |
	'searchWixCodeSdk' |
	'seo' |
	'seoTpa' |
	'seoWixCodeSdk' |
	'serviceRegistrar' |
	'sessionManager' |
	'sessionManagerService' |
	'siteMembers' |
	'siteMembersService' |
	'siteMembersWixCodeSdk' |
	'siteOverflow' |
	'siteScrollBlocker' |
	'siteScrollBlockerService' |
	'siteThemeService' |
	'siteWixCodeSdk' |
	'sliderGallery' |
	'sosp' |
	'speculationRules' |
	'ssrCache' |
	'stickyToComponent' |
	'stores' |
	'storesWixCodeSdk' |
	'structureApi' |
	'styleUtilsService' |
	'svgLoader' |
	'telemetryWixCodeSdk' |
	'testApi' |
	'testService' |
	'thunderboltInitializer' |
	'thunderboltLogger' |
	'tinyMenu' |
	'topologyService' |
	'tpa' |
	'tpaCommons' |
	'tpaModuleProvider' |
	'tpaWorkerFeature' |
	'translations' |
	'translationsService' |
	'triggersAndReactions' |
	'urlService' |
	'usedPlatformApis' |
	'versionIndicator' |
	'viewMode' |
	'viewerManagerActionApi' |
	'viewerManagerActionsAndBehaviorsApi' |
	'viewerManagerAnimationApi' |
	'viewerManagerBlocksApi' |
	'viewerManagerByRefApi' |
	'viewerManagerComponentApi' |
	'viewerManagerComponentDetectorApi' |
	'viewerManagerComponentPreviewApi' |
	'viewerManagerCustomCss' |
	'viewerManagerCustomElementsApi' |
	'viewerManagerDataApi' |
	'viewerManagerDiagnosticsApi' |
	'viewerManagerDisplayedOnlyComponentsApi' |
	'viewerManagerDocumentServicesModelApi' |
	'viewerManagerExternalComponentsApi' |
	'viewerManagerFontsApi' |
	'viewerManagerLayoutApi' |
	'viewerManagerLivePreviewApi' |
	'viewerManagerMembersApi' |
	'viewerManagerModesApi' |
	'viewerManagerMultilingualApi' |
	'viewerManagerNavigationApi' |
	'viewerManagerPagesApi' |
	'viewerManagerPlatformApi' |
	'viewerManagerQueryApi' |
	'viewerManagerRealTimeConfigApi' |
	'viewerManagerRenderFlagsApi' |
	'viewerManagerRendererModelApi' |
	'viewerManagerResponsiveApi' |
	'viewerManagerRuntimeApi' |
	'viewerManagerRuntimeLayoutApi' |
	'viewerManagerScopesApi' |
	'viewerManagerScrollApi' |
	'viewerManagerStructureApi' |
	'viewerManagerStylableApi' |
	'viewerManagerSvgApi' |
	'viewerManagerTpaApi' |
	'viewerManagerUpdateStatusApi' |
	'viewerManagerVariantsApi' |
	'viewerManagerVeloApi' |
	'visibility' |
	'warmupData' |
	'welcomeScreen' |
	'widget' |
	'widgetWixCodeSdk' |
	'windowMessageRegistrar' |
	'windowScroll' |
	'windowWixCodeSdk' |
	'wixCustomElementComponent' |
	'wixEcomFrontendWixCodeSdk' |
	'wixEmbedsApi' |
	'wixEventsWixCodeSdk' |
	'wixapps' |
	'wrichtextWrapOnAdd'

export type FeaturesConfig = Partial<Record<FeatureName | '__componentsConfig__', any>>
export type PageFeaturesConfig = Partial<Omit<Record<FeatureName | '__componentsConfig__', any>, 'render'>> & {
	render: RenderConfig
}
